import $ from 'jquery';
import './index.css';

import CrystalSimulation from './simulation/CrystalSimulation';

$(() => { new CrystalSimulation().start(); });



// WEBPACK FOOTER //
// ./src/index.js